<template>
  <div class="goods-list">
    <template v-for="goods in goodsList" :key="goods.id">
      <div class="main_box">
        <div class="main_box_l">
          <el-image :src="goods.thumb" :preview-src-list="[goods.thumb]" fit="cover" />
        </div>
        <div class="main_box_r flex-column">
          <div class="main_title">
            {{ goods.title }}
          </div>
          <div class="main_spec" v-if="goods.skuname != 'name'">
            {{ goods.skuname }}
          </div>
          <div class="main_price">
            <div>
              <span class="good_price" v-if="goods.points"> {{ goods.points }} 积分 </span>
              <span class="good_price" v-if="goods.amount && goods.points"> &emsp;+&emsp; </span>
              <span class="good_price" v-if="goods.amount"> ¥{{ goods.amount }} </span>
              <span class="good_price" v-else> ¥0 </span>
              <span class="good_num"> x {{ goods.num }} </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
  import { defineProps } from 'vue'

  defineProps({
    goodsList: {
      type: Array,
      required: true
    }
  })
</script>

<style lang="scss" scoped>
  .goods-list {
    .main_box {
      width: 100%;
      height: auto;
      background: #fff;
      display: flex;
      text-align: left;
      flex-wrap: wrap;
      margin-top: 10px;
      border-bottom: 1px solid #f2f3f5;
      padding-bottom: 15px;
      padding-top: 5px;

      .main_box_l {
        display: flex;
        align-items: center;
        width: 200px;
        height: 200px;
        border-radius: 10px;
        overflow: hidden;
      }

      .main_box_r {
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
        font-size: 14px;
        margin-left: 12px;

        .main_title {
          color: #333;
          font-weight: bold;
          overflow: hidden;
          display: -webkit-box;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
        }

        .main_spec {
          color: #999;
          font-size: 12px;
        }

        .main_price {
          color: #eb3a2a;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: bold;
        }

        .good_num {
          color: #9a9a9a;
          font-size: 14px;
          margin-left: 20px;
        }
      }
    }
  }
</style>
